<template>
    <div class="item-inner">
        <div class="item-head">
            <p class="ellipsis" :title="source.app_name">{{source.app_name}}({{source.app_id}})</p>
            <!-- <span>({{source.app_id}})</span> mi_over_title -->
        </div>
        <div 
            class="item-child" 
            v-for="child in source.children"
            :key="child.param_id"
        >
            <span>{{child.param_name}}：{{child.num}}</span>
        </div>
    </div>
  </template>
  
  <script>
  
  export default {
    name: 'ad-source-item',
    props: {
      source: {
        type: Object,
        default () {
          return {}
        }
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .item-inner {
    padding-left: 12px;
    .item-head {
    display: flex;
    align-items: center;
    padding: 6px 0 0;
    p {
        max-width: 80%;
    }
    
    }
    .item-child {
    padding-left: 20px;
    margin-top: 6px;
    } 
  }
  </style>